import { Home, Mic, Search, Square } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useDetection } from '../contexts/DetectionContext';
import { trackNavigationClick } from '../utils/analytics';
export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { startDetection, stopDetection, isDetecting } = useDetection();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-20 border-t border-neutral-200 bg-white/95 backdrop-blur-lg dark:border-neutral-800 dark:bg-neutral-900/95">
      <div className="bottom-nav">
        <div className="flex items-center justify-around">
          {/* Home button */}
          <button
            className={`tap-target flex cursor-pointer flex-col items-center gap-1 px-3 py-2 transition-colors duration-200 ${
              location.pathname === '/'
                ? 'text-neutral-900 dark:text-neutral-100'
                : 'text-neutral-400 dark:text-neutral-600'
            } `}
            onClick={() => {
              trackNavigationClick('Home');
              // Don't stop detection when navigating
              void navigate('/');
            }}
          >
            <Home className="h-6 w-6" />
            <span className="text-xs font-medium">Home</span>
          </button>

          {/* Center Detect Button */}
          <button
            onClick={() => {
              if (isDetecting) {
                stopDetection();
              } else {
                if (location.pathname !== '/') {
                  void navigate('/');
                }
                // Small delay to ensure navigation completes before starting detection
                setTimeout(() => {
                  startDetection();
                }, 100);
              }
            }}
            className="tap-target flex flex-col items-center gap-1 px-3 py-2"
          >
            <div
              className={`rounded-full p-3 ${
                isDetecting
                  ? 'bg-red-600 dark:bg-red-500'
                  : 'bg-emerald-600 dark:bg-emerald-500'
              }`}
            >
              {isDetecting ? (
                <Square className="h-5 w-5 text-white" />
              ) : (
                <Mic className="h-5 w-5 text-white" />
              )}
            </div>
            <span
              className={`text-xs font-medium ${
                isDetecting
                  ? 'text-red-600 dark:text-red-400'
                  : 'text-emerald-600 dark:text-emerald-400'
              }`}
            >
              {isDetecting ? 'Stop' : 'Record'}
            </span>
          </button>

          {/* Search button */}
          <button
            className={`tap-target flex cursor-pointer flex-col items-center gap-1 px-3 py-2 transition-colors duration-200 ${
              location.pathname === '/search'
                ? 'text-neutral-900 dark:text-neutral-100'
                : 'text-neutral-400 dark:text-neutral-600'
            } `}
            onClick={() => {
              // Track navigation
              trackNavigationClick('Search');
              // Don't stop detection - allow simultaneous search and recording
              void navigate('/search');
            }}
          >
            <Search className="h-6 w-6" />
            <span className="text-xs font-medium">Search</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
